import { htmlSafe } from '@ember/template';
import Modal from 'tio-reimagined/components/modal';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import TioErrorMessages from '../../tio/error-messages.gts';

export interface TuitionAssistanceLimitsSummaryErrorAlertSignature {
  Args: {
    showError: boolean;
    errorMessage: string;
    explanation: string;
  };
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

export default class TuitionAssistanceLimitsSummaryErrorAlertComponent extends Component<TuitionAssistanceLimitsSummaryErrorAlertSignature> {
  @tracked isShowingDetailsDialog = false;

  toggleDetailsDialog = () => {
    this.isShowingDetailsDialog = !this.isShowingDetailsDialog;
  };

  <template>
    {{#if @showError}}
      <div class="flex flex-col" ...attributes>
        <TioErrorMessages @showErrors={{@showError}} @error={{@errorMessage}} @icon="warning" />
        <button type="button" class="tio-anchor" {{on "click" this.toggleDetailsDialog}}>
          {{t "tuition_assistance.limits_summary.explain_limit"}}
        </button>
      </div>
      <Modal
        @isOpen={{this.isShowingDetailsDialog}}
        @onClose={{this.toggleDetailsDialog}}
        @ariaLabel={{t "common.aria_labels.limit_explanation"}}
      >
        <:body>
          {{htmlSafe @explanation}}
        </:body>
      </Modal>
    {{/if}}
  </template>
}
